import React from "react";
import Modal from "../../../componentLibrary/Modal";

interface LessonErrorModalProps {
  isModalOpen: boolean;
  onCloseModal: () => void;
  lessonErrors: { text: string }[];
  totalPageErrors: {
    pageTitle: string;
    pageErrors: { text: string; pageId: string; componentId: string }[];
  }[];
  onErrorClick?: (pageId: string, componentId: string) => void;
}

export default function LessonErrorModal({
  isModalOpen,
  onCloseModal,
  lessonErrors,
  totalPageErrors,
  onErrorClick,
}: LessonErrorModalProps) {
  return (
    <Modal
      isOpen={isModalOpen}
      onCloseModal={onCloseModal}
      title="Validation Errors"
    >
      <div className="space-y-4">
        {lessonErrors.length > 0 && (
          <div>
            <h3 className="font-semibold mb-2">Lesson Errors:</h3>
            <ul className="list-disc pl-5 space-y-1">
              {lessonErrors.map((error, index) => (
                <li key={index} className="text-red-600">
                  {error.text}
                </li>
              ))}
            </ul>
          </div>
        )}
        {totalPageErrors.length > 0 && (
          <div>
            <h3 className="font-semibold mb-2">Page Errors:</h3>
            {totalPageErrors.map((pageError, pageIndex) => (
              <div key={pageIndex} className="mb-4">
                <h4 className="font-medium mb-2">
                  Page: {pageError.pageTitle || "Untitled"}
                </h4>
                <ul className="list-disc pl-5 space-y-1">
                  {pageError.pageErrors.map((error, errorIndex) => (
                    <li
                      key={errorIndex}
                      className={`text-red-600 ${
                        onErrorClick ? "cursor-pointer hover:underline" : ""
                      }`}
                      onClick={() => {
                        if (onErrorClick) {
                          onErrorClick(error.pageId, error.componentId);
                          onCloseModal();
                        }
                      }}
                    >
                      {error.text}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
